import React from 'react';
import { Tooltip, tooltipClasses, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: '#fff',
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        color: '#000',
        borderRadius: '10px',
        padding: '10px 14px',
        boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.35)',
        fontSize: '13px',
        maxWidth: 240,
        minWidth: 150
    },
}));

const CustomTooltip = ({
    title = "Contains",
    content = "",
    children,
    placement = "top-end",
    arrow = true,
    ...props
}) => {
    return (
        <StyledTooltip
            placement={placement}
            arrow={arrow}
            title={
                <Box sx={{ p: 0.2 }}>
                    {title && (
                        <Typography
                            sx={{
                                color: '#FF6B4A',
                                fontWeight: 700,
                                fontSize: '13px',
                                lineHeight: 1.3,
                                mb: 0.4,
                            }}
                        >
                            {title}
                        </Typography>
                    )}
                    {content && (
                        <Typography
                            sx={{
                                color: '#000',
                                fontWeight: 500,
                                fontSize: '13px',
                                lineHeight: 1.3,
                            }}
                        >
                            {content}
                        </Typography>
                    )}
                </Box>
            }
            {...props}
        >
            {children}
        </StyledTooltip>
    );
};

export default CustomTooltip;
